// Copyright (c) 2017 Deere & Company

import {
    onCreateClaim,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetClaimsInProgress,
    updateClaimStatus
} from './select-status';
import {
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
} from './search-filters';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {handleSearchAction} from '../../claim-search/action-creators/handle-search-action';
import {readClaimTypes} from './get-claim-types';
import {readClaims} from './read-claims';

export default {
    ...exportToExcelActions,
    handleSearchAction,
    onCreateClaim,
    readClaimTypes,
    readClaims,
    resetClaimsInProgress,
    updateClaimStatus,
    updateCreateClaimModalVisibility,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
};



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/action-creators/index.js